// extracted by mini-css-extract-plugin
module.exports = {"btnAdd":"styles_btnAdd__1RqwL","table":"styles_table__3NC5O","planDetailsBtn":"styles_planDetailsBtn__UEngV","custom":"styles_custom__1mTt1","footer":"styles_footer__2qWij"};